import { useRef, useState } from "react";
import { useClickOutside } from "../hooks";
import { images } from "../assets/img";
import { useAppStore } from "../store/useAppStore";

const langItems = {
  uk: {
    name: "English",
    icon: images.icon["uk_flag"],
    val: "uk",
  },
  ro: {
    name: "Română",
    icon: images.icon["ro_flag"],
    val: "ro",
  },
  ru: {
    name: "Русский",
    icon: images.icon["ru_flag"],
    val: "ru",
  },
};

export function Language() {
  const [isOpen, setIsOpen] = useState(false);
  const { appLang, setAppLang } = useAppStore();
  const langRef = useRef(null);
  useClickOutside(langRef, () => setIsOpen(false));

  function handleLangClick(val) {
    setAppLang(val);
    setIsOpen(false);
  }

  return (
    <div className="language" ref={langRef}>
      <div
        className={`selected ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="roundFlagCont">
          <img
            className="flagIcon"
            src={langItems[appLang]?.icon}
            alt={langItems[appLang]?.name}
          />
        </div>
        <div className="arr down"></div>
      </div>
      <div className={`list shadow1 ${isOpen ? "open" : ""}`}>
        {Object.values(langItems).map((el) => (
          <div
            className={`item ${el.val === appLang ? "active" : ""}`}
            key={el.val}
            onClick={() => handleLangClick(el.val)}
          >
            <div className="roundFlagCont">
              <img className="flagIcon" src={el.icon} alt="" />
            </div>
            {el.name}
          </div>
        ))}
      </div>
    </div>
  );
}
